import React from 'react';
import { useIntl } from 'react-intl';

import { FieldBlock, FieldInput } from '../../ui';
import { MapDivider, MappingInputWrapper, MapWrapper } from './style';
import { MappingFieldsList } from './utils';

export const MappingFields = (): JSX.Element => {
  const intl = useIntl();
  return (
    <FieldBlock
      title={intl.formatMessage({ id: 'enterprise-connection.settings.map.title' })}
      description={intl.formatMessage({
        id: 'enterprise-connection.settings.map.description'
      })}
      notification={intl.formatMessage({
        id: 'enterprise-connection.settings.map.notification'
      })}>
      {MappingFieldsList.map((item) => {
        return (
          <MapWrapper>
            <MappingInputWrapper>
              <FieldInput name={`xsolla_${item}`} value={item.substring(4)} disabled />
            </MappingInputWrapper>
            <MapDivider />
            <MappingInputWrapper>
              <FieldInput
                name={item}
                // Commented, pending translation capacity
                // placeholder={intl.formatMessage({
                //   id: `enterprise-connection.settings.map.${item.substring(4)}.placeholder`
                // })}
                data-test-id={`oauth2_field_${item}`}
              />
            </MappingInputWrapper>
          </MapWrapper>
        );
      })}
    </FieldBlock>
  );
};
